import Vue from 'vue'

const useLogPlugin = function (container) {
  Vue.$log = container.log
  Vue.prototype.$log = Vue.$log
}

export default useLogPlugin



// WEBPACK FOOTER //
// ./src/plugins/log.js